<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Historia del presupuesto</h1>
                <router-link exact :to="'/presupuesto/' + presupuesto_id" class="display-1">Presupuesto Nº {{ presupuesto_id }}</router-link>
                <v-progress-linear :indeterminate="true" :active="loading"></v-progress-linear>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <v-timeline align-top dense>
                    <template v-for="h in historia">
                        <v-timeline-item small>
                            <!--CAMBIO DE ESTADO///////////////////////////////-->
                            <v-layout pt-3 v-if="h.operacion.id === 1">
                                <v-flex xs3>
                                    <strong>{{ h.created_at | filterFecha }} <br> {{ h.created_at | tiempo }}</strong>
                                </v-flex>
                                <v-flex>
                                    <strong>{{ h.operacion.desig }} | ID {{ h.presupuesto_items_id}}</strong>
                                    <div>
                                        <v-chip small>
                                            <v-avatar>
                                                <v-icon :color="h.estado_desde.color">{{ h.estado_desde.icono }}</v-icon>
                                            </v-avatar>
                                            {{ h.estado_desde.desig }}
                                        </v-chip>
                                        <v-icon>arrow_forward</v-icon>
                                        <v-chip small>
                                            <v-avatar>
                                                <v-icon :color="h.estado_hasta.color">{{ h.estado_hasta.icono }}</v-icon>
                                            </v-avatar>
                                            {{ h.estado_hasta.desig }}
                                        </v-chip>
                                    </div>
                                    <div v-if="h.user">
                                        Usuario: {{ h.user.name }}
                                    </div>
                                </v-flex>
                            </v-layout>
                            <!--EDICION DE ITEM///////////////////////////////-->
                            <v-layout  pt-3 v-else-if="h.operacion.id === 6 || h.operacion.id === 4">
                                <v-flex xs3>
                                    <strong>{{ h.created_at | filterFecha }} <br> {{ h.created_at | tiempo }}</strong>
                                </v-flex>
                                <v-flex>
                                    <strong>{{ h.operacion.desig }} | ID {{ h.presupuesto_items_id}}</strong>
                                    <div>
                                        <b>{{ h.operacion.desig }}</b>:
                                        {{ (h.presupuesto_item.item_tipo)? h.presupuesto_item.item_tipo.desig : '' }}
                                        {{ (h.presupuesto_item.item)? h.presupuesto_item.item.descripcion : '' }}
                                    </div>
                                    <div v-if="h.user">
                                        Usuario: {{ h.user.name }}
                                    </div>
                                </v-flex>
                            </v-layout>
                            <!--DEFAULT///////////////////////////////-->
                            <v-layout pt-3 v-else >
                                <v-flex xs3>
                                    <strong>{{ h.created_at | filterFecha }} <br> {{ h.created_at | tiempo }}</strong>
                                </v-flex>
                                <v-flex>
                                    <strong>{{ h.operacion.desig }}</strong>
                                    <div v-if="h.user">
                                        Usuario: {{ h.user.name }}
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-timeline-item>
                    </template>
                </v-timeline>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
    import filterFecha from '../../filters/fecha-db'
    import moment from 'moment';

    moment.locale('es');

    export default {
        name: "item",
        filters: {
            filterFecha,
            tiempo(v) {
                return moment(v).fromNow();
            }
        },
        data() {
            return {
                loading: false,
                presupuesto_id: this.$store.state.route.params.presup,
                historia: []
            }
        },
        mounted() {
            this.datos();
        },
        methods: {
            datos() {
                this.loading = true;
                this.$http.post('historia/presupuesto', {presupuesto_id: this.presupuesto_id})
                    .then(r => {
                        this.historia = r.data;
                        this.loading = false;
                    }, err => {
                        this.loading = false;
                    })
            }
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/presup/historia.vue